import { Module } from 'vuex';

import { RecommendedCourseKeyword, RootState } from 'frontend/types';
import { postData } from 'frontend/utils/ajax';
import { stringifyQueryParams } from 'frontend/utils/urls';
import { stat } from 'fs';

interface RecommendedCourseKeywordState {
  items: RecommendedCourseKeyword[];
  highlightSearch: boolean;
  highlightRecentCourses: boolean;
  viewedKeywordsIntro: boolean;
}

const recommendedCourseKeywords: Module<RecommendedCourseKeywordState, RootState> = {
  namespaced: true,
  state: {
    items: [] as RecommendedCourseKeyword[],
    highlightSearch: false,
    highlightRecentCourses: false,
    viewedKeywordsIntro: false,
  },
  mutations: {
    setValue(state: RecommendedCourseKeywordState, value: RecommendedCourseKeyword[]): void {
      state.items = value;
    },
    setHighlightSearch(state: RecommendedCourseKeywordState, value: boolean) {
      state.highlightSearch = value;
    },
    setHighlightRecentCourses(state: RecommendedCourseKeywordState, value: boolean) {
      state.highlightRecentCourses = value;
    },
    setViewedKeywordsIntro(state: RecommendedCourseKeywordState) {
      state.viewedKeywordsIntro = true;
    },
  },
  actions: {
    highlightSearch({ commit }, value: boolean) {
      commit('setHighlightSearch', value);
    },
    highlightRecentCourses({ commit }) {
      commit('setHighlightRecentCourses', true);
    },
    viewedKeywordsIntro({ commit }) {
      commit('setViewedKeywordsIntro');
    },
    async sendKeywords({ commit }, keywordIds: number[]): Promise<boolean> {
      let response;
      try {
        response = await postData(
          '/courses/process-keywords/',
          stringifyQueryParams({
            keywords: JSON.stringify(keywordIds),
          }),
        );
      } catch (e) {
        return false;
      }
      if (response?.results?.recent_courses) {
        commit('recentCourses/addRecommendedCourses', response.results.recent_courses, {
          root: true,
        });
        return true;
      }
      return false;
    },
  },
  getters: {
    recommendedCourseKeywords: (state: RecommendedCourseKeywordState): RecommendedCourseKeyword[] =>
      state.items,
  },
};

export default recommendedCourseKeywords;
